export const CHECKIN_CONFIG = {
  // URL del channel manager (pagine pubbliche su book.nonnavittoriaapartments.it)
  IFRAME_URL: 'https://book.nonnavittoriaapartments.it/checkin/embedded',

  // La versione dell'app nell'indirizzo dell'iframe (nvaApp=2). Solo con
  // questa il channel manager tiene il flag embedded nel modulo, nella
  // pagina di successo e nel ritorno da Stripe, e manda CHECKIN_FORM_READY,
  // CHECKIN_FORM_SUBMITTED e CHECKIN_COMPLETED. Le app col bundle vecchio
  // (service worker) non la mandano: per loro il check-in resta com'era.
  APP_VERSION_PARAM: 'nvaApp',
  APP_VERSION: '2',

  // La lingua dell'app nell'indirizzo dell'iframe (lang=de): il check-in
  // parte nella lingua che l'ospite ha scelto in app, non in quella del
  // telefono. Il channel manager vecchio la ignora.
  LANG_PARAM: 'lang',

  // Origini consentite per postMessage
  ALLOWED_ORIGINS: [
    'https://book.nonnavittoriaapartments.it',
    'https://extranet.nonnavittoriaapartments.it',
    'http://localhost:3000',
    'http://localhost:3001'
  ],
  
  // Timeout per caricamento iframe (30 secondi)
  IFRAME_TIMEOUT: 30000,
  
  // ✅ MODIFICATO: 7 giorni prima invece di 3
  CHECKIN_AVAILABLE_DAYS_BEFORE: 7,
  
  // Giorni dopo il check-in in cui rimane disponibile
  CHECKIN_AVAILABLE_DAYS_AFTER: 1
};

// Verifica ESATTA dell'origine (solo match esatto per sicurezza)
export const isAllowedOrigin = (origin: string): boolean => {
  return CHECKIN_CONFIG.ALLOWED_ORIGINS.includes(origin);
};

/**
 * Il link del check-in di GRUPPO arriva dal channel manager
 * (/guest/group-bookings → checkInUrl) senza nvaApp e senza lingua: il
 * channel manager non li aggiunge, così le app col bundle vecchio restano
 * sul percorso di sempre. L'app nuova li attacca da sé (nvaApp=2, lang) e
 * aggiunge il telefono (deviceId) se manca.
 *
 * Un link che non è del channel manager (origine non ammessa: i messaggi
 * dell'iframe non arriverebbero mai) o scritto male: si ricostruisce
 * dall'indirizzo dell'iframe di sempre, con email e riferimento.
 */
export function groupCheckInUrl(
  checkInUrl: string | null | undefined,
  opts: { lang: string; deviceId?: string | null; email?: string | null; bookingRef?: string | null },
): string {
  let url: URL | null = null;
  try {
    url = checkInUrl ? new URL(checkInUrl) : null;
  } catch {
    url = null;
  }
  if (!url || !isAllowedOrigin(url.origin)) {
    url = new URL(CHECKIN_CONFIG.IFRAME_URL);
    if (opts.email) url.searchParams.set('email', opts.email);
    if (opts.bookingRef) url.searchParams.set('bookingRef', opts.bookingRef);
  }
  if (opts.deviceId && !url.searchParams.has('deviceId')) url.searchParams.set('deviceId', opts.deviceId);
  url.searchParams.set(CHECKIN_CONFIG.APP_VERSION_PARAM, CHECKIN_CONFIG.APP_VERSION);
  url.searchParams.set(CHECKIN_CONFIG.LANG_PARAM, opts.lang);
  return url.toString();
}
